import { render, staticRenderFns } from "./SupplierMerchantContract.vue?vue&type=template&id=84c2ff4e&scoped=true"
import script from "./SupplierMerchantContract.vue?vue&type=script&lang=js"
export * from "./SupplierMerchantContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c2ff4e",
  null
  
)

export default component.exports